export default "__VITE_ASSET__6dfa928a__"